import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useRef, useState } from 'react';
import useWindowSize from '../../../hooks/useWindowSize';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({
                     additionalClass = "",
                     formattedData = {},
                     valuePrefix = ''
                   }) => {
  const chartRef = useRef(null);
  const [axisTooltip, setAxisTooltip] = useState(null);
  const { isMobile } = useWindowSize();

  const handleMouseMove = (event) => {
    if (!chartRef.current) return;

    const chart = chartRef.current;
    const { y: yScale } = chart.scales;
    const canvasBounds = chart.canvas.getBoundingClientRect();
    const wrapperBounds = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - canvasBounds.left;
    const y = event.clientY - canvasBounds.top;
    const isOverYAxis = x >= yScale.left && x <= yScale.right
      && y >= yScale.top && y <= yScale.bottom;

    if (!isOverYAxis) {
      setAxisTooltip(null);
      return;
    }

    setAxisTooltip({
      left: yScale.right + 8,
      top: event.clientY - wrapperBounds.top,
      value: Math.round(yScale.getValueForPixel(y)),
    });
  };

  const options = {
    responsive: true,
    aspectRatio: isMobile ? 0.75 : 1.25,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${valuePrefix}${value}`,
        },
      },
    },
    plugins: {
      legend: {
        display: formattedData.datasets.length > 0 && formattedData.datasets[0] !== "-1",
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: 'rect',
        },
      },
      title: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(data) {
            const eventLabel = data.dataset.tooltipLabel || data.dataset.label || '';
            const currency = data.dataset.tooltipCurrency || '';

            return `${eventLabel}: ${currency}${data.raw}`;
          }
        }
      },
    },
  };

  return (
    <div
      className="position-relative"
      onMouseMove={handleMouseMove}
      onMouseLeave={() => setAxisTooltip(null)}
    >
      <Line
        ref={chartRef}
        options={options}
        data={formattedData}
        className={`my-4 ${additionalClass}`}
      />
      {axisTooltip && (
        <div
          className="axis-tooltip position-absolute translate-middle-y z-1 text-white px-2 py-1 rounded fs-7 pe-none"
          style={{ left: `${axisTooltip.left}px`, top: `${axisTooltip.top}px` }}
        >
          {valuePrefix}{axisTooltip.value.toLocaleString()}
        </div>
      )}
    </div>
  );
};

export default LineChart;
